import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useWindowSize } from '@react-hook/window-size';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentRelabelInit,
  viewerPhotoDocumentRelabel,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentRelabel.style';
// import { Breakpoints } from '../../assets/Variables.style';

const PhotoDocumentRelabelInner = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentRelabelStore = useSelector(
    (state) => state.viewerPhotoDocumentRelabelStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentRelabelStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentRelabel({ id }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentRelabelInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentRelabel.wrapper}>
        <Header theme={theme.photoDocumentRelabel.header}>
          <Title theme={theme.photoDocumentRelabel.title}>
            {intl.formatMessage({
              id: 'RELABEL_PHOTO_DOCUMENT.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentRelabel.text.default}>
                {intl.formatMessage({
                  id: `RELABEL_PHOTO_DOCUMENT.TEXT.THE_PHOTO_DOCUMENT_HAS_BEEN_SUCCESSFULLY_RELABELED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'RELABEL_PHOTO_DOCUMENT.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentRelabel.wrapper}>
            <Header theme={theme.photoDocumentRelabel.header}>
              <Title theme={theme.photoDocumentRelabel.title}>
                {intl.formatMessage({
                  id: 'RELABEL_PHOTO_DOCUMENT.RELABEL_PHOTO_DOCUMENT',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentRelabel.text.default}>
                    {intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENT.TEXT.ARE_YOU_SURE_WANT_TO_RELABEL_PHOTO_DOCUMENT`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENT.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentRelabel.text.error}>
                  {intl.formatMessage({
                    id: `RELABEL_PHOTO_DOCUMENT.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'RELABEL_PHOTO_DOCUMENT.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'RELABEL_PHOTO_DOCUMENT.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENT.RELABEL`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentRelabel = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  // const [width] = useWindowSize();
  return (
    <Modal
      handleClose={handleClose}
      // fullscreen={width <= Breakpoints.md ? true : false}
    >
      <PhotoDocumentRelabelInner
        id={id}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentRelabelInner.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentRelabel.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentRelabel;
